module.exports = "<template>\n    <sio-log object.one-time=\"{id: object.id, modelId: object.modelId}\" tab.one-time=\"tab\"></sio-log>\n</template>\n";